import ReactMarkdown from 'react-markdown'
import { TextPage } from 'routes/components/TextPage/TextPage'
import Text from 'md/esign-disclosure-consent.md'

const EsignDisclosureConsentPage = () => (
  <TextPage title="Settle E-Sign Disclosure and Consent">
    <ReactMarkdown>{Text}</ReactMarkdown>
  </TextPage>
)

export default EsignDisclosureConsentPage
